/**
 * Módulo cierre de caja: conteo por método, diferencias e impresión de ticket.
 */

function cierreState(win) {
	if (!win._posknCierreState) {
		win._posknCierreState = { detalles: null, cajaId: null };
	}
	return win._posknCierreState;
}

function getAjaxUrl(win) {
	const cfg = win.POSKN_API_CONFIG || {};
	return cfg.ajaxUrl || win.ajaxurl || 'pos-ajax.php';
}

function escapeHtml(str) {
	return String(str || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

function formatDescuentoTicket(monto) {
	const n = parseFloat(monto) || 0;
	if (Math.abs(n - Math.round(n)) < 0.001) return String(Math.round(n));
	return n.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
}

function buildDescuentosTicketHtml(detalles) {
	const lista = (detalles && detalles.descuentos_pedidos) || [];
	let total = detalles ? parseFloat(detalles.descuentos_total || 0) : 0;
	if (lista.length > 0 && total < 0.005) {
		total = lista.reduce((acc, d) => acc + (parseFloat(d.monto) || 0), 0);
	}
	let html = '<div class="ticket-seccion"><strong>DESCUENTOS</strong></div>';
	if (total > 0.005 || lista.length > 0) {
		html += `<div class="ticket-fila">Total: -$${total.toFixed(2)}</div>`;
		lista.forEach((d) => {
			const num = escapeHtml(String(d.numero || d.order_id || ''));
			html += `<div class="ticket-fila">${num} -${formatDescuentoTicket(d.monto)}$</div>`;
		});
	} else {
		html += '<div class="ticket-fila">(Ninguno)</div>';
	}
	html += '<div class="ticket-linea">------------------------------</div>';
	return html;
}

function buildCreditosTicketHtml(detalles) {
	const lista = (detalles && detalles.creditos_pedidos) || [];
	let total = detalles ? parseFloat(detalles.creditos_total || 0) : 0;
	if (lista.length > 0 && total < 0.005) {
		total = lista.reduce((acc, c) => acc + (parseFloat(c.monto) || 0), 0);
	}
	let html = '<div class="ticket-seccion"><strong>CRÉDITOS</strong></div>';
	if (total > 0.005 || lista.length > 0) {
		html += `<div class="ticket-fila">Total: $${total.toFixed(2)}</div>`;
		lista.forEach((c) => {
			const num = escapeHtml(String(c.numero || c.order_id || ''));
			const cli = escapeHtml(String(c.cliente || '').trim());
			html += `<div class="ticket-fila">#${num}${cli ? ` · ${cli}` : ''}: $${(parseFloat(c.monto) || 0).toFixed(2)}</div>`;
		});
	} else {
		html += '<div class="ticket-fila">(Ninguno)</div>';
	}
	html += '<div class="ticket-linea">------------------------------</div>';
	return html;
}

function esMetodoCreditoCierre(metodo) {
	const m = String(metodo || '').toLowerCase();
	return m === 'credito' || m === 'pago-credito';
}

function esMetodoEfectivoCierre(win, metodo) {
	if (typeof win.metodoEsEfectivo === 'function') {
		return win.metodoEsEfectivo(metodo);
	}
	const m = String(metodo || '')
		.toLowerCase()
		.replace(/[_\s]/g, '-');
	return m.indexOf('efectivo') !== -1 || m === 'cash';
}

function formatMetodoTicket(win, metodo) {
	if (typeof win.formatearNombreMetodo === 'function') return win.formatearNombreMetodo(metodo);
	return String(metodo || '')
		.replace(/-/g, ' ')
		.replace(/\b\w/g, (l) => l.toUpperCase());
}

function buildAbonosCreditoTicketHtml(win, detalles) {
	const lista = (detalles && detalles.abonos_credito) || [];
	const totalUsd = detalles ? parseFloat(detalles.abonos_credito_total_usd || 0) : 0;
	const totalBs = detalles ? parseFloat(detalles.abonos_credito_total_bs || 0) : 0;
	if (totalUsd < 0.005 && totalBs < 0.005 && lista.length === 0) {
		return '';
	}
	let html = '<div class="ticket-seccion"><strong>ABONOS DE CRÉDITO</strong></div>';
	let totalLine = `Total cobrado: $${totalUsd.toFixed(2)}`;
	if (totalBs > 0.005) totalLine += ` / Bs. ${totalBs.toFixed(2)}`;
	html += `<div class="ticket-fila">${totalLine}</div>`;
	html += '<div class="ticket-fila">(Incluidos en métodos de pago)</div>';
	lista.forEach((a) => {
		const mon = String(a.moneda || 'USD').toUpperCase() === 'BS' ? 'BS' : 'USD';
		const sym = mon === 'BS' ? 'Bs. ' : '$';
		const met = a.metodo_pago ? ` · ${escapeHtml(formatMetodoTicket(win, a.metodo_pago))}` : '';
		const desc = escapeHtml(String(a.descripcion || 'Abono'));
		html += `<div class="ticket-fila">${desc}${met}: ${sym}${(parseFloat(a.monto) || 0).toFixed(2)}</div>`;
	});
	html += '<div class="ticket-linea">------------------------------</div>';
	return html;
}

function esGastoAbonoCredito(g) {
	return String((g && g.categoria) || '').toLowerCase() === 'abono-credito';
}

function getCurrentUserName(win) {
	const ej = win.posknEjecutorFacturacion || {};
	return ej.nombre || '';
}

function metodoEsBs(win, metodo) {
	if (typeof win.posknMetodoEsBs === 'function') return win.posknMetodoEsBs(metodo);
	const m = String(metodo || '').toLowerCase();
	const map = win.POSKN_METODO_MONEDA || {};
	if (Object.prototype.hasOwnProperty.call(map, m)) {
		return String(map[m]).toUpperCase() === 'BS';
	}
	return m.indexOf('-bs') !== -1 || m.indexOf('_bs') !== -1;
}

function initCierreAdminEvents(win, $) {
	if (win._posknCierreAdminBound) return;
	win._posknCierreAdminBound = true;

	$(document).on('click', '#btn-realizar-cierre', () => win.realizarCierreCaja());
	$(document).on('click', '#btn-imprimir-cierre-ticket', () => win.imprimirTicketCierreResultados());
	$(document).on('click', '#btn-cierre-modal-reimprimir', () => {
		if (typeof win.reimprimirUltimoCierre === 'function') win.reimprimirUltimoCierre();
		else if (typeof win.imprimirTicketCierreResultados === 'function') win.imprimirTicketCierreResultados();
	});
	$(document).on('click', '#btn-cierre-modal-nueva-sesion', () => {
		if (typeof win.iniciarNuevaSesionCaja === 'function') win.iniciarNuevaSesionCaja();
		else if (typeof win.abrirNuevaCaja === 'function') win.abrirNuevaCaja();
	});
	$(document).on('click', '#btn-cierre-modal-logout', () => {
		if (typeof win.cerrarSesionCajeroTrasCierre === 'function') win.cerrarSesionCajeroTrasCierre();
	});
	$(document).on('click', '#btn-cierre-modal-cerrar', () => {
		if (typeof win.cerrarModal === 'function') win.cerrarModal('modal-cierre-completado');
		else $('#modal-cierre-completado').hide();
	});
}

export function attachCierreAdminGlobals(win, $) {
	initCierreAdminEvents(win, $);
	const state = () => cierreState(win);

	win.renderCierreResumenCompleto = function renderCierreResumenCompleto(datos) {
		if (!datos) {
			$('#cierre-resumen-completo').empty();
			return;
		}
		let html = '';
		const gastos = datos.gastos || [];
		const productos = datos.productos_vendidos || [];
		const descuentos = parseFloat(datos.descuentos_total || 0);
		const descuentosLista = datos.descuentos_pedidos || [];
		if (descuentos > 0 || descuentosLista.length > 0) {
			html +=
				'<div class="cierre-seccion-extra" style="background:#fff8e1;border-radius:8px;border-left:4px solid #ff9800;padding:16px;margin-bottom:12px;">';
			html += '<h3 style="margin:0 0 8px 0;color:#e65100;">🏷️ Descuentos del turno</h3>';
			html += `<p style="margin:0 0 8px 0;font-size:14px;"><strong>Total descontado:</strong> -$${descuentos.toFixed(2)}</p>`;
			if (descuentosLista.length > 0) {
				html += '<ul style="margin:0;padding-left:18px;font-size:13px;">';
				descuentosLista.forEach((d) => {
					html += `<li><strong>${escapeHtml(String(d.numero || d.order_id))}</strong> -${formatDescuentoTicket(d.monto)}$</li>`;
				});
				html += '</ul>';
			}
			html += '</div>';
		}
		const creditosUi = parseFloat(datos.creditos_total || 0);
		const creditosListaUi = datos.creditos_pedidos || [];
		if (creditosUi > 0.005 || creditosListaUi.length > 0) {
			html +=
				'<div class="cierre-seccion-extra" style="background:#ffebee;border-radius:8px;border-left:4px solid #c62828;padding:16px;margin-bottom:12px;">';
			html += '<h3 style="margin:0 0 8px 0;color:#c62828;">Créditos del turno</h3>';
			html += `<p style="margin:0 0 6px 0;font-size:14px;"><strong>Total a crédito:</strong> $${creditosUi.toFixed(2)}</p>`;
			html +=
				'<p style="margin:0 0 8px 0;font-size:12px;color:#555;">Se reporta en caja y en el ticket. No se cuenta como efectivo del cajón.</p>';
			if (creditosListaUi.length > 0) {
				html += '<ul style="margin:0;padding-left:18px;font-size:13px;">';
				creditosListaUi.forEach((c) => {
					const num = escapeHtml(String(c.numero || c.order_id || ''));
					const cli = escapeHtml(String(c.cliente || '').trim());
					html += `<li><strong>#${num}</strong>${cli ? ` · ${cli}` : ''} — $${parseFloat(c.monto || 0).toFixed(2)}</li>`;
				});
				html += '</ul>';
			}
			html += '</div>';
		}
		const abonosUsdUi = parseFloat(datos.abonos_credito_total_usd || 0);
		const abonosBsUi = parseFloat(datos.abonos_credito_total_bs || 0);
		const abonosListaUi = datos.abonos_credito || [];
		if (abonosUsdUi > 0.005 || abonosBsUi > 0.005 || abonosListaUi.length > 0) {
			html +=
				'<div class="cierre-seccion-extra" style="background:#e8f5e9;border-radius:8px;border-left:4px solid #2e7d32;padding:16px;margin-bottom:12px;">';
			html += '<h3 style="margin:0 0 8px 0;color:#2e7d32;">💵 Abonos de crédito cobrados</h3>';
			html += `<p style="margin:0 0 6px 0;font-size:14px;"><strong>Total cobrado:</strong> $${abonosUsdUi.toFixed(2)}`;
			if (abonosBsUi > 0.005) html += ` · Bs. ${abonosBsUi.toFixed(2)}`;
			html += '</p>';
			html +=
				'<p style="margin:0 0 8px 0;font-size:12px;color:#555;">Estos montos ya están sumados al método de pago correspondiente en la caja.</p>';
			if (abonosListaUi.length > 0) {
				html += '<ul style="margin:0;padding-left:18px;font-size:13px;">';
				abonosListaUi.forEach((a) => {
					const mon = String(a.moneda || 'USD').toUpperCase() === 'BS' ? 'Bs. ' : '$';
					const met = a.metodo_pago ? ` · ${escapeHtml(formatMetodoTicket(win, a.metodo_pago))}` : '';
					html += `<li>${escapeHtml(a.descripcion || 'Abono')}${met} — ${mon}${parseFloat(a.monto || 0).toFixed(2)}</li>`;
				});
				html += '</ul>';
			}
			html += '</div>';
		}
		const gastosSinAbonos = gastos.filter((g) => !esGastoAbonoCredito(g));
		if (gastosSinAbonos.length > 0) {
			html +=
				'<div class="cierre-seccion-extra" style="background:#f9f9f9;border-radius:8px;border-left:4px solid #ffb900;padding:16px;">';
			html += '<h3 style="margin:0 0 12px 0;color:#ffb900;">💰 Movimientos de caja chica</h3>';
			html +=
				'<div style="max-height:220px;overflow-y:auto;"><table style="width:100%;border-collapse:collapse;font-size:13px;">';
			html +=
				'<thead><tr style="background:#eee;"><th style="text-align:left;padding:6px 8px;">Descripción</th><th style="text-align:left;padding:6px 8px;">Categoría</th><th style="text-align:right;padding:6px 8px;">Monto</th></tr></thead><tbody>';
			gastosSinAbonos.forEach((g) => {
				const moneda = (g.moneda || 'USD').toUpperCase();
				const montoStr = `${moneda === 'BS' ? 'Bs. ' : '$'}${parseFloat(g.monto || 0).toFixed(2)}`;
				html += `<tr><td style="padding:6px 8px;">${escapeHtml(g.descripcion)}</td><td style="padding:6px 8px;">${escapeHtml(g.categoria)}</td><td style="text-align:right;padding:6px 8px;">${montoStr}</td></tr>`;
			});
			html += '</tbody></table></div></div>';
		}
		if (productos.length > 0) {
			html +=
				'<div class="cierre-seccion-extra" style="background:#f9f9f9;border-radius:8px;border-left:4px solid #0073aa;padding:16px;">';
			html += '<h3 style="margin:0 0 12px 0;color:#0073aa;">📦 Productos vendidos</h3>';
			html +=
				'<div style="max-height:220px;overflow-y:auto;"><table style="width:100%;border-collapse:collapse;font-size:13px;">';
			html +=
				'<thead><tr style="background:#eee;"><th style="text-align:left;padding:6px 8px;">Producto</th><th style="text-align:center;padding:6px 8px;">Cant.</th><th style="text-align:right;padding:6px 8px;">Total</th></tr></thead><tbody>';
			productos.forEach((p) => {
				const qty = parseInt(p.quantity, 10) || 0;
				const total = parseFloat(p.total || 0).toFixed(2);
				html += `<tr><td style="padding:6px 8px;">${escapeHtml(p.name)}</td><td style="text-align:center;padding:6px 8px;">${qty} unid.</td><td style="text-align:right;padding:6px 8px;">$${total}</td></tr>`;
			});
			html += '</tbody></table></div></div>';
		}
		$('#cierre-resumen-completo').html(html || '').toggle(html.length > 0);
	};

	win.cargarDatosCierre = function cargarDatosCierre() {
		$('#cierre-resultado').hide().empty();
		$('#btn-confirmar-cerrar-caja').hide();
		$('#btn-imprimir-cierre-ticket').hide();

		win.POSKN.api.getCajaStatus(15000)
			.then((response) => {
				if (!response.success || response.data.estado !== 'abierta') {
					$('#cierre-sin-caja').show();
					$('#cierre-contenido').hide();
					return;
				}
				$('#cierre-sin-caja').hide();
				state().cajaId = response.data.caja_id;

				$.ajax({
					url: getAjaxUrl(win),
					method: 'POST',
					dataType: 'json',
					data: { action: 'pos_obtener_detalles_caja', caja_id: state().cajaId },
					success(resDetalles) {
						if (!resDetalles.success || !resDetalles.data) {
							$('#cierre-sin-caja').show();
							$('#cierre-contenido').hide();
							return;
						}
						state().detalles = resDetalles.data;
						const metodos = state().detalles.metodos_pago || {};
						const nombres = state().detalles.metodos_pago_nombres || {};
						const moneda = state().detalles.metodos_pago_moneda || {};
						let html = '';
						const simbolo = (m) => (moneda[m] === 'BS' ? 'Bs. ' : '$');
						const nombre = (m) =>
							nombres[m] ||
							m.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

						html +=
							'<div class="cierre-metodo-fila cierre-header-fila" style="background:#e0e0e0;font-weight:bold;">';
						html +=
							'<span class="metodo-nombre">Método</span><span>Monto en caja</span>';
						html +=
							'<span class="cierre-esperado">Esperado</span><span class="cierre-diferencia">Diferencia</span></div>';

						Object.entries(metodos).forEach(([metodo, esperado]) => {
							const esp = parseFloat(esperado) || 0;
							if (Math.abs(esp) < 0.005) return;
							if (esMetodoCreditoCierre(metodo)) return;
							const sim = simbolo(metodo);
							const esEfectivo = esMetodoEfectivoCierre(win, metodo);
							const filaClass = esEfectivo ? 'cierre-metodo-fila' : 'cierre-metodo-fila cierre-fila-auto';
							const inputClass = esEfectivo ? 'cierre-input cierre-input-efectivo' : 'cierre-input cierre-input-auto';
							const valorInicial = esEfectivo ? '' : esp.toFixed(2);
							const ro = esEfectivo ? '' : ' readonly tabindex="-1"';
							const ph = esEfectivo ? 'Contar efectivo' : 'Total sistema';
							html += `<div class="${filaClass}" data-metodo="${metodo}" data-moneda="${moneda[metodo] || 'USD'}" data-esperado="${esp}" data-efectivo="${esEfectivo ? '1' : '0'}">`;
							html += `<span class="metodo-nombre">${nombre(metodo)}</span>`;
							html += `<input type="number" step="0.01" min="0" class="${inputClass}" placeholder="${ph}" data-metodo="${metodo}" value="${valorInicial}"${ro}>`;
							html += `<span class="cierre-esperado">${sim}${esp.toFixed(2)}</span>`;
							html += '<span class="cierre-diferencia" data-diff></span></div>';
						});

						if (!html) {
							html = '<p>No hay movimientos por método de pago para esta caja.</p>';
						}

						$('#cierre-metodos-grid').html(html).addClass('cierre-antes').removeClass('cierre-despues');
						win.renderCierreResumenCompleto(state().detalles);
						$('#cierre-contenido').show();
						$('#cierre-alerta-mesas-ocupadas').hide();

						$.ajax({
							url: getAjaxUrl(win),
							method: 'POST',
							dataType: 'json',
							data: {
								action: 'pos_tiene_mesas_ocupadas',
								tienda_id:
									win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id
										? parseInt(win.posknTiendaSeleccionada.id, 10)
										: 0,
							},
							success(resMesas) {
								if (resMesas.success && resMesas.ocupadas) {
									$('#cierre-alerta-mesas-ocupadas').show();
									$('#btn-realizar-cierre').prop('disabled', true);
									$('.cierre-input').prop('disabled', true).off('input change');
									$('#cierre-resumen-completo').hide();
									return;
								}
								$('#cierre-resumen-completo').show();
								const actualizarEstadoBotonCierre = () => {
									const $cash = $('.cierre-input-efectivo');
									if (!$cash.length) {
										$('#btn-realizar-cierre').prop('disabled', false);
										return;
									}
									let completo = true;
									$cash.each(function eachCash() {
										const val = $(this).val();
										if (val === null || String(val).trim() === '') {
											completo = false;
											return false;
										}
										return undefined;
									});
									$('#btn-realizar-cierre').prop('disabled', !completo);
								};
								actualizarEstadoBotonCierre();
								$('.cierre-input-efectivo').on('input change', actualizarEstadoBotonCierre);
							},
						});
					},
					error() {
						$('#cierre-sin-caja').show();
						$('#cierre-contenido').hide();
					},
				});
			})
			.catch(() => {
				$('#cierre-sin-caja').show();
				$('#cierre-contenido').hide();
			});
	};

	win.realizarCierreCaja = function realizarCierreCaja() {
		const pendientes =
			typeof win.posknHayPedidosPendientesLocales === 'function'
				? win.posknHayPedidosPendientesLocales()
				: { ok: false, count: 0 };
		if (pendientes.ok && pendientes.count > 0) {
			win.mostrarNotificacion(
				`No se puede cerrar caja: hay ${pendientes.count} pedido(s) en cola o enviándose. Espera a que suban o anula el envío para no perder la venta.`,
				'error',
			);
			if (typeof win.procesarColaSubida === 'function') win.procesarColaSubida();
			if (pendientes.reason === 'cola' && typeof win.verListaPendientesSubir === 'function') {
				win.verListaPendientesSubir();
			}
			return;
		}
		const detalles = state().detalles;
		if (!detalles) return;

		$('#cierre-metodos-grid').removeClass('cierre-antes').addClass('cierre-despues');
		const moneda = detalles.metodos_pago_moneda || {};
		let totalFaltoUsd = 0;
		let totalFaltoBs = 0;
		let totalSobroUsd = 0;
		let totalSobroBs = 0;

		$('.cierre-metodo-fila').each(function eachFila() {
			const $fila = $(this);
			if ($fila.hasClass('cierre-header-fila')) return;
			const metodo = $fila.data('metodo');
			if (esMetodoCreditoCierre(metodo)) return;
			const esperado = parseFloat($fila.data('esperado')) || 0;
			const ingresado = parseFloat($fila.find('.cierre-input').val()) || 0;
			const diff = ingresado - esperado;
			const esBs = (moneda[metodo] || 'USD') === 'BS';
			$fila.removeClass('cierre-diff-falto cierre-diff-sobro cierre-diff-igual');
			const sim = esBs ? 'Bs. ' : '$';
			if (Math.abs(diff) < 0.01) {
				$fila.addClass('cierre-diff-igual');
				$fila.find('[data-diff]').text('✓ Igual').css('color', '#2e7d32');
			} else if (diff < 0) {
				$fila.addClass('cierre-diff-falto');
				$fila
					.find('[data-diff]')
					.text(`Falta ${sim}${Math.abs(diff).toFixed(2)}`)
					.css('color', '#c62828');
				if (esBs) totalFaltoBs += Math.abs(diff);
				else totalFaltoUsd += Math.abs(diff);
			} else {
				$fila.addClass('cierre-diff-sobro');
				$fila.find('[data-diff]').text(`Sobra ${sim}${diff.toFixed(2)}`).css('color', '#546e7a');
				if (esBs) totalSobroBs += diff;
				else totalSobroUsd += diff;
			}
		});

		let resumen = '<div class="resumen-total">';
		if (totalFaltoUsd > 0 || totalFaltoBs > 0) {
			resumen += `<p style="color: #c62828;">Total que falta: $${totalFaltoUsd.toFixed(2)}${totalFaltoBs > 0 ? ` / Bs. ${totalFaltoBs.toFixed(2)}` : ''}</p>`;
		}
		if (totalSobroUsd > 0 || totalSobroBs > 0) {
			resumen += `<p style="color: #546e7a;">Total que sobra: $${totalSobroUsd.toFixed(2)}${totalSobroBs > 0 ? ` / Bs. ${totalSobroBs.toFixed(2)}` : ''}</p>`;
		}
		resumen += '</div>';
		$('#cierre-resultado').html(resumen).show();
		$('#btn-imprimir-cierre-ticket').hide();

		if (!state().cajaId) return;

		const tasa = win.TASA_DOLAR || 1;
		let totalUsd = 0;
		let totalBs = 0;
		const cierresPorMetodo = {};

		$('.cierre-metodo-fila').each(function eachFilaTotales() {
			if ($(this).hasClass('cierre-header-fila')) return;
			const metodoFila = $(this).data('metodo');
			if (esMetodoCreditoCierre(metodoFila)) return;
			const val = parseFloat($(this).find('.cierre-input').val()) || 0;
			const esBs = ($(this).data('moneda') || 'USD') === 'BS';
			if (esBs) totalBs += val;
			else totalUsd += val;
			const metodo = $(this).data('metodo');
			if (metodo) cierresPorMetodo[metodo] = val;
		});

		const montoCierreTotal = totalUsd + totalBs / tasa;
		const cajaIdCierre = parseInt(state().cajaId, 10) || 0;
		const $btn = $('#btn-realizar-cierre').prop('disabled', true).text('Cerrando...');

		function mensajeAjaxCierre(err, fallback) {
			try {
				if (err && err.responseJSON && err.responseJSON.data) {
					const d = err.responseJSON.data;
					if (typeof d === 'string' && d) return d;
					if (d && typeof d.message === 'string' && d.message) return d.message;
				}
				if (err && typeof err.data === 'string' && err.data) return err.data;
			} catch (e) {
				/* ignore */
			}
			return fallback;
		}

		function finalizarCierreConfirmado(data) {
			win.mostrarNotificacion('Caja cerrada correctamente', 'success');
			if (typeof win.mostrarResumenCierre === 'function') {
				win.mostrarResumenCierre(data);
			}
			$('.cierre-input').prop('disabled', true);
			$btn.prop('disabled', true).text('Caja cerrada');
			$('#btn-confirmar-cerrar-caja').prop('disabled', true).hide();
			$('#btn-imprimir-cierre-ticket').show();
			if (typeof win.reconciliarEstadoCaja === 'function') {
				win.reconciliarEstadoCaja();
			} else if (typeof win.cargarEstadoCaja === 'function') {
				win.cargarEstadoCaja();
			}
			if (typeof win.mostrarModalCierreCompletado === 'function') {
				win.mostrarModalCierreCompletado(
					Object.assign({ estado: 'cerrada', caja_id: cajaIdCierre }, data || {}),
					{ autoPrint: true, cerrado: true },
				);
			}
		}

		function cajaQuedoCerrada(st) {
			const d = st && st.data ? st.data : {};
			return (
				String(d.estado || '').toLowerCase() === 'cerrada' &&
				cajaIdCierre > 0 &&
				parseInt(d.caja_id, 10) === cajaIdCierre
			);
		}

		function rechazarCierreNoConfirmado(msg) {
			$btn.prop('disabled', false).text('Realizar cierre');
			$('#btn-imprimir-cierre-ticket').hide();
			win.mostrarNotificacion(msg, 'error');
			if (typeof win.reconciliarEstadoCaja === 'function') win.reconciliarEstadoCaja();
		}

		function verificarCierreEnServidor(data) {
			const api = win.POSKN && win.POSKN.api;
			if (!api || typeof api.verifyCaja !== 'function' || cajaIdCierre <= 0) {
				rechazarCierreNoConfirmado(
					'No se pudo verificar el cierre por ID. No se imprime ticket hasta confirmar que la caja quedó cerrada.',
				);
				return;
			}
			api
				.verifyCaja(cajaIdCierre, 15000)
				.then((st) => {
					if (cajaQuedoCerrada(st)) {
						finalizarCierreConfirmado(data);
						return;
					}
					if (data && String(data.estado || '').toLowerCase() === 'cerrada') {
						finalizarCierreConfirmado(data);
						return;
					}
					const estado = String((st && st.data && st.data.estado) || 'abierta').toUpperCase();
					rechazarCierreNoConfirmado(
						'El ticket no se imprime: la caja #' + cajaIdCierre + ' sigue ' + estado + ' en el servidor. Reintenta el cierre.',
					);
				})
				.catch(() => {
					if (data && String(data.estado || '').toLowerCase() === 'cerrada') {
						finalizarCierreConfirmado(data);
						return;
					}
					rechazarCierreNoConfirmado(
						'No se pudo verificar el cierre. No se imprime ticket hasta confirmar que la caja quedó cerrada.',
					);
				});
		}

		win.POSKN.api.closeCaja(montoCierreTotal, cierresPorMetodo, 60000, cajaIdCierre)
			.then((response) => {
				if (response.success && response.data && String(response.data.estado || '').toLowerCase() === 'cerrada') {
					verificarCierreEnServidor(response.data);
				} else {
					$btn.prop('disabled', false).text('Realizar cierre');
					$('#btn-imprimir-cierre-ticket').hide();
					win.mostrarNotificacion(`Error: ${response.data || 'El cierre no se guardó'}`, 'error');
					if (typeof win.reconciliarEstadoCaja === 'function') win.reconciliarEstadoCaja();
				}
			})
			.catch((xhr) => {
				$btn.prop('disabled', false).text('Realizar cierre');
				$('#btn-imprimir-cierre-ticket').hide();
				win.mostrarNotificacion(
					mensajeAjaxCierre(
						xhr,
						'Error de conexión al cerrar. Se verificará el estado real de la caja…',
					),
					'warning',
				);
				const api = win.POSKN && win.POSKN.api;
				if (api && typeof api.verifyCaja === 'function' && cajaIdCierre > 0) {
					api.verifyCaja(cajaIdCierre, 15000)
						.then((st) => {
							if (cajaQuedoCerrada(st)) {
								win.mostrarNotificacion(
									'La caja ya está cerrada en el servidor. Puedes reimprimir o abrir el siguiente turno.',
									'success',
								);
								finalizarCierreConfirmado(st.data || { caja_id: cajaIdCierre, estado: 'cerrada' });
							}
						})
						.catch(() => {
							if (typeof win.reconciliarEstadoCaja === 'function') {
								win.reconciliarEstadoCaja();
							}
						});
				} else if (typeof win.reconciliarEstadoCaja === 'function') {
					win.reconciliarEstadoCaja();
				}
			});
	};

	win.mostrarModalCierreCompletado = function mostrarModalCierreCompletado(data, opts) {
		const options = opts || {};
		const d = data || {};
		const esperado =
			d.monto_esperado != null
				? parseFloat(d.monto_esperado)
				: parseFloat(d.monto_inicial || 0) + parseFloat(d.ventas_total || 0);
		const declarado = parseFloat(d.monto_cierre || 0);
		const diferencia =
			d.diferencia_cierre != null ? parseFloat(d.diferencia_cierre) : declarado - esperado;

		const filas = [];
		$('.cierre-metodo-fila').each(function eachFilaSnap() {
			if ($(this).hasClass('cierre-header-fila')) return;
			filas.push({
				nombre: $(this).find('.metodo-nombre').text().trim(),
				enCaja: $(this).find('.cierre-input').val() || '0',
				esperado: $(this).find('.cierre-esperado').text().trim(),
				diferencia: $(this).find('.cierre-diferencia').text().trim(),
			});
		});

		win._posknUltimoCierre = {
			...d,
			monto_esperado: esperado,
			diferencia_cierre: diferencia,
			filas,
			resumenHtml: $('#cierre-resultado').html() || '',
			detalles: state().detalles,
			fecha: new Date().toISOString(),
			cerrado: options.cerrado === true && String(d.estado || '').toLowerCase() === 'cerrada',
		};

		win.datosCierre = {
			...(win.datosCierre || {}),
			...d,
			diferencia,
			total_esperado: esperado,
			detalles: (win.datosCierre && win.datosCierre.detalles) || state().detalles || null,
		};

		$('#cierre-modal-caja-id').text(d.caja_id != null ? String(d.caja_id) : '—');
		$('#cierre-modal-esperado').text(esperado.toFixed(2));
		$('#cierre-modal-declarado').text(declarado.toFixed(2));
		$('#cierre-modal-diferencia').text(diferencia.toFixed(2));

		const $modal = $('#modal-cierre-completado');
		if ($modal.length) {
			$modal.css('display', 'flex').addClass('show');
		}

		if (options.autoPrint !== false && win._posknUltimoCierre && win._posknUltimoCierre.cerrado) {
			win.setTimeout(() => {
				if (typeof win.reimprimirUltimoCierre === 'function') win.reimprimirUltimoCierre();
			}, 450);
		}
	};

	win.reimprimirUltimoCierre = function reimprimirUltimoCierre() {
		const snap = win._posknUltimoCierre;
		if (!snap || snap.cerrado === false) {
			win.mostrarNotificacion('No hay un cierre confirmado para imprimir. La caja no se cerró.', 'error');
			return;
		}
		if (snap && Array.isArray(snap.filas) && snap.filas.length > 0) {
			win.imprimirTicketCierreResultados(snap);
			return;
		}
		if ($('.cierre-metodo-fila').not('.cierre-header-fila').length > 0) {
			win.imprimirTicketCierreResultados();
			return;
		}
		if (typeof win.imprimirCierre === 'function' && (win.datosCierre || snap)) {
			if (!win.datosCierre && snap) {
				win.datosCierre = {
					...snap,
					diferencia: snap.diferencia_cierre,
					total_esperado: snap.monto_esperado,
				};
			}
			win.imprimirCierre();
			return;
		}
		win.mostrarNotificacion('No hay datos de cierre para reimprimir', 'error');
	};

	win.limpiarEstadoTurnoCaja = function limpiarEstadoTurnoCaja() {
		const carrito = win.carrito || (win.carrito = []);
		carrito.splice(0, carrito.length);
		win.pedidoMesaAbierto = null;
		win.mesaSeleccionada = null;
		win.clienteSeleccionado = null;
		win.descuentoActual = { tipo: 'porcentaje', valor: 0, activo: false };
		$('#mesa-badge').hide();
		$('#mesa-seleccionada-compacto').hide();
		$('#mesa-indicador-carrito').hide();
		$('#cliente-seleccionado').hide();
		$('#cliente-badge').hide();
		$('#cliente-seleccionado-compacto').hide();
		$('#cliente-buscar').val('');
		$('#descuento-tipo').val('porcentaje');
		$('#descuento-valor').val('');
		$('#descuento-activo').hide();
		try {
			win.localStorage.removeItem('pos_borrador_pedido');
			win.localStorage.removeItem('pos_pedido_enviando');
		} catch (e) {
			/* ignore */
		}
		if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();
		if (typeof win.seleccionarTipoServicio === 'function') win.seleccionarTipoServicio('comer');
		if (typeof win.actualizarBotonesMesa === 'function') win.actualizarBotonesMesa();
	};

	win.iniciarNuevaSesionCaja = function iniciarNuevaSesionCaja() {
		if (
			!win.confirm(
				'¿Abrir el siguiente turno de caja con $0.00 / Bs. 0.00?\n\nÚsalo para cambio diurno → nocturno (u otro turno) sin cambiar de cajero.',
			)
		) {
			return;
		}
		const labelDefault = 'Abrir siguiente turno (nueva caja $0)';
		const $btn = $('#btn-cierre-modal-nueva-sesion').prop('disabled', true).text('Abriendo...');
		win.POSKN.api
			.openCaja(0, 0, 20000)
			.then((response) => {
				$btn.prop('disabled', false).text(labelDefault);
				if (!response || !response.success) {
					win.mostrarNotificacion(
						`Error: ${(response && response.data) || 'No se pudo abrir la caja'}`,
						'error',
					);
					return;
				}
				win.limpiarEstadoTurnoCaja();
				if (typeof win.cerrarModal === 'function') win.cerrarModal('modal-cierre-completado');
				else $('#modal-cierre-completado').hide();
				if (typeof win.cargarEstadoCaja === 'function') win.cargarEstadoCaja();
				if (typeof win.cargarDatosCierre === 'function') win.cargarDatosCierre();
				if (typeof win.volverInicio === 'function') win.volverInicio();
				win.mostrarNotificacion('Siguiente turno de caja abierto', 'success');
			})
			.catch(() => {
				$btn.prop('disabled', false).text(labelDefault);
				win.mostrarNotificacion('Error de conexión al abrir nueva caja', 'error');
			});
	};

	win.cerrarSesionCajeroTrasCierre = function cerrarSesionCajeroTrasCierre() {
		if (
			!win.confirm(
				'¿Cerrar la sesión del cajero?\n\nSe irá al login del POS para que entre otro usuario (cambio de cajero / fin de jornada).',
			)
		) {
			return;
		}
		if (typeof win.limpiarEstadoTurnoCaja === 'function') win.limpiarEstadoTurnoCaja();
		try {
			win.localStorage.removeItem('pos_borrador_pedido');
			win.localStorage.removeItem('pos_pedido_enviando');
			win.sessionStorage.clear();
		} catch (e) {
			/* ignore */
		}
		const url =
			win.POSKN_LOGOUT_URL ||
			(typeof win.posknLogoutUrl === 'string' ? win.posknLogoutUrl : '');
		if (!url) {
			win.mostrarNotificacion('No se encontró la URL de cierre de sesión', 'error');
			return;
		}
		win.location.href = url;
	};

	win.imprimirTicketCierreResultados = function imprimirTicketCierreResultados(snapshot) {
		const snap = snapshot || win._posknUltimoCierre || null;
		if (!snap || snap.cerrado === false) {
			win.mostrarNotificacion(
				'No se imprime ticket de cierre: la caja no está confirmada como cerrada.',
				'error',
			);
			return;
		}
		let filas = [];
		if (snap && Array.isArray(snap.filas) && snap.filas.length > 0) {
			filas = snap.filas;
		} else {
			$('.cierre-metodo-fila').each(function eachFilaTicket() {
				if ($(this).hasClass('cierre-header-fila')) return;
				filas.push({
					nombre: $(this).find('.metodo-nombre').text().trim(),
					enCaja: $(this).find('.cierre-input').val() || '0',
					esperado: $(this).find('.cierre-esperado').text().trim(),
					diferencia: $(this).find('.cierre-diferencia').text().trim(),
				});
			});
		}

		const resumenHtml =
			(snap && snap.resumenHtml) || $('#cierre-resultado').html() || '';
		const ahora = new Date();
		const fechaStr = `${ahora.toLocaleDateString('es-ES')} ${ahora.toLocaleTimeString('es-ES')}`;
		const usuario = getCurrentUserName(win);
		const detalles = (snap && snap.detalles) || state().detalles;
		let ventasUsd = 0;
		let ventasBs = 0;

		if (detalles) {
			if (detalles.total_usd != null) ventasUsd = parseFloat(detalles.total_usd) || 0;
			if (detalles.total_bs != null) ventasBs = parseFloat(detalles.total_bs) || 0;
			if (
				ventasUsd === 0 &&
				ventasBs === 0 &&
				detalles.metodos_pago &&
				detalles.metodos_pago_moneda
			) {
				const mp = detalles.metodos_pago;
				const monedaMap = detalles.metodos_pago_moneda || {};
				Object.keys(mp).forEach((metodo) => {
					const esBs =
						(monedaMap[metodo] || '').toUpperCase() === 'BS' || metodoEsBs(win, metodo);
					const val = parseFloat(mp[metodo]) || 0;
					if (esBs) ventasBs += val;
					else ventasUsd += val;
				});
			}
		}

		let body = '<div class="ticket">';
		const cajaLabel = snap && snap.caja_id ? ` #${snap.caja_id}` : '';
		body += `<div class="ticket-header"><strong>CIERRE DE CAJA${cajaLabel}</strong></div>`;
		body += '<div class="ticket-fecha">CERRADA</div>';
		body += `<div class="ticket-fecha">${fechaStr}</div>`;
		body += `<div class="ticket-fecha">${escapeHtml(usuario)}</div>`;
		body += '<div class="ticket-linea">------------------------------</div>';
		body += '<div class="ticket-seccion"><strong>VENTAS REALIZADAS</strong></div>';

		let descuentosUsd = detalles ? parseFloat(detalles.descuentos_total || 0) : 0;
		let subtotalProductos = 0;
		if (detalles && detalles.productos_vendidos) {
			detalles.productos_vendidos.forEach((p) => {
				subtotalProductos += parseFloat(p.total || 0);
			});
		}
		if (descuentosUsd < 0.005 && subtotalProductos > ventasUsd + 0.005) {
			descuentosUsd = subtotalProductos - ventasUsd;
		}
		if (subtotalProductos > 0.005 && descuentosUsd > 0.005) {
			body += `<div class="ticket-fila">Subtotal productos: $${subtotalProductos.toFixed(2)}</div>`;
		}

		body += `<div class="ticket-fila">Ventas USD: $${ventasUsd.toFixed(2)}</div>`;
		body += `<div class="ticket-fila">Ventas Bs: Bs. ${ventasBs.toFixed(2)}</div>`;
		body += '<div class="ticket-linea">------------------------------</div>';
		body += '<div class="ticket-seccion"><strong>Método | En caja | Esperado | Dif.</strong></div>';
		body += '<div class="ticket-linea">------------------------------</div>';
		filas.forEach((r) => {
			body += `<div class="ticket-fila">${escapeHtml(r.nombre)}</div>`;
			body += `<div class="ticket-fila">  En caja: ${escapeHtml(r.enCaja)} | Esperado: ${escapeHtml(r.esperado)}</div>`;
			body += `<div class="ticket-fila">  ${escapeHtml(r.diferencia)}</div>`;
		});
		body += '<div class="ticket-linea">------------------------------</div>';
		const resumenTexto = resumenHtml.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
		if (resumenTexto) body += `<div class="ticket-resumen">${escapeHtml(resumenTexto)}</div>`;
		body += '<div class="ticket-linea">------------------------------</div>';
		body += '<div class="ticket-seccion"><strong>MOVIMIENTOS CAJA CHICA</strong></div>';
		const gastosTicket = ((detalles && detalles.gastos) || []).filter((g) => !esGastoAbonoCredito(g));
		if (gastosTicket.length > 0) {
			gastosTicket.forEach((g) => {
				const moneda = (g.moneda || 'USD').toUpperCase();
				const montoStr = `${moneda === 'BS' ? 'Bs. ' : '$'}${parseFloat(g.monto || 0).toFixed(2)}`;
				body += `<div class="ticket-fila">${escapeHtml(g.descripcion)} (${escapeHtml(g.categoria)}): ${montoStr}</div>`;
			});
		} else {
			body += '<div class="ticket-fila">(Ninguno)</div>';
		}
		body += '<div class="ticket-linea">------------------------------</div>';
		body += buildDescuentosTicketHtml(detalles);
		body += buildCreditosTicketHtml(detalles);
		body += buildAbonosCreditoTicketHtml(win, detalles);
		body += '<div class="ticket-seccion"><strong>PRODUCTOS VENDIDOS</strong></div>';
		const productosTicket =
			detalles && detalles.productos_vendidos ? detalles.productos_vendidos : [];
		if (productosTicket.length > 0) {
			productosTicket.forEach((p) => {
				const qty = parseInt(p.quantity, 10) || 0;
				const total = parseFloat(p.total || 0).toFixed(2);
				const name = String(p.name || '').normalize('NFC');
				body += `<div class="ticket-fila">${qty}x ${escapeHtml(name)}: $${total}</div>`;
			});
		} else {
			body += '<div class="ticket-fila">(Ninguno)</div>';
		}
		body += '<div class="ticket-linea">------------------------------</div>';
		body += '<div class="ticket-footer">Sistema POS - Cierre de Caja</div></div>';

		const estilos =
			'body{margin:8px;padding:0;font-family:"Courier New",monospace;font-size:12px;line-height:1.3;color:#000;font-weight:bold;}' +
			' .ticket{max-width:300px;}' +
			' .ticket-header{text-align:center;font-size:16px;font-weight:900;text-transform:uppercase;margin-bottom:2px;}' +
			' .ticket-seccion{text-align:center;font-size:13px;font-weight:900;margin-bottom:2px;}' +
			' .ticket-fecha{text-align:center;font-size:11px;margin:1px 0;}' +
			' .ticket-footer{text-align:center;font-size:10px;margin-top:4px;}' +
			' .ticket-linea{text-align:center;font-weight:bold;margin:3px 0;}' +
			' .ticket-fila{margin:2px 0;}' +
			' .ticket-resumen{margin:8px 0;white-space:normal;font-weight:bold;}' +
			' @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact;color:#000;font-weight:bold;}}';

		const fullHtml = `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>${estilos}</style><title>Ticket Cierre</title></head><body>${body}</body></html>`;
		if (typeof win.posknPrint === 'function') {
			win.posknPrint({
				title: 'Ticket Cierre',
				html: fullHtml,
				kind: 'cierre',
				onSuccess: () => win.mostrarNotificacion('Ticket enviado a impresión', 'success'),
			});
			return;
		}
		const printWin = win.open('', '_blank', 'width=400,height=700');
		if (!printWin) {
			win.mostrarNotificacion('Permite ventanas emergentes para imprimir el ticket.', 'error');
			return;
		}
		printWin.document.write(fullHtml);
		printWin.document.close();
		win.setTimeout(() => {
			try {
				printWin.print();
				win.setTimeout(() => printWin.close(), 1500);
			} catch (e) {
				win.mostrarNotificacion('Error al imprimir', 'error');
			}
		}, 400);
		win.mostrarNotificacion('Ticket enviado a impresión', 'success');
	};
}
